<div class="heading py-5">
  <h1 class="bold font-curve-large">Typography</h1>
  <app-dependency-link documentationPath="content/typography"></app-dependency-link>
</div>

<app-typography-demo></app-typography-demo>
